import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { filter, fromEvent, map, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'gen-auto-ship-shipment-frequency',
  templateUrl: './auto-ship-shipment-frequency.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GenAutoShipShipmentFrequencyComponent implements AfterViewInit, OnDestroy {

  @ViewChild('shipmentInput') shipmentInput!: ElementRef<HTMLInputElement>;
  @Output() numberOfShipmentsChange = new EventEmitter<number>();

  private readonly maxShipments: number = 99;
  private destroy$ = new Subject<void>();

  ngAfterViewInit(): void {
    fromEvent(this.shipmentInput.nativeElement, 'input')
      .pipe(
        map(() => {
          const input = this.shipmentInput.nativeElement;
          let value = input.value.replace(/[^0-9]/g, '');

          // Remove leading zeros
          value = value.replace(/^0+/, '');

          // Limit the input length
          value = value.slice(0, 2);

          // Enforce the maximum
          if (Number(value) > this.maxShipments) {
            value = String(this.maxShipments);
          }

          input.value = value;
          return value;
        }),
        filter(v => v != ''),
        takeUntil(this.destroy$)
      )
      .subscribe(value => {
        this.numberOfShipmentsChange.emit(Number(value));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}